module.exports = { id: "brochure", url: "/build/app/img/symbols.svg#brochure", viewBox: "", toString: function() { return this.url; } };